<template>
  <div>
    <div class="row" v-if="alert">
      <div :class="{
        [ full ? 'col-12' : $ALERT_COL ]: true
      }">
        <Alert icon="IconMoodHappy" class="alert-info" title="100% of our good customers leave us a review!">
          <p class="mb-1">Reviews helps us make our product better and keeps us energized.</p>
          <p class="mb-0"><a class="alert-link" href="https://apps.shopify.com/superchargify#modal-show=ReviewListingModal" target="_blank" rel="noopener">Leave us a review <IconExternalWindow class="ml-1 match-icon-color" height="16" style="vertical-align: text-bottom" /></a></p>
        </Alert>
      </div>
    </div>
    <div class="card bs" v-else>
      <div class="card-body">
        <div class="form-group mb-0">
          <p class="font-weight-normal">100% of our good customers leave us a review. It helps us make our product better and keeps us energized.</p>

          <a class="btn btn-primary" href="https://apps.shopify.com/superchargify#modal-show=ReviewListingModal" target="_blank" rel="noopener">Leave us a review <IconExternalWindow class="ml-1 match-icon-color" height="18" style="vertical-align: text-bottom" /></a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    alert: Boolean,
    full: Boolean
  }
}
</script>
